import styled, { css } from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
export const Button = styled.button.withConfig(testableStyledComponentConfig) `
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background-color: ${(props) => props.backgroundColor};
    transition: transform 200ms ease-in-out;

    ${(props) => !props.disabled &&
    css `
            cursor: pointer;
            &:hover {
                transform: scale(1.3);
            }
        `}
`;
//# sourceMappingURL=index.js.map